module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "choice"
  }, [_c('span', {
    staticClass: "choice-button tit",
    class: {
      inactive: !_vm.browse
    },
    on: {
      "click": function($event) {
        _vm.browse = true
      }
    }
  }, [_vm._v("Browse")]), _vm._v(" "), _c('span', {
    staticClass: "choice-button tit",
    class: {
      inactive: _vm.browse
    },
    on: {
      "click": function($event) {
        _vm.browse = false
      }
    }
  }, [_vm._v("Info")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.browse) ? _c('div', [_c('div', {
    staticClass: "browse"
  }, [_c('div', {
    staticClass: "browse-filters"
  }, [_c('div', {
    staticClass: "browse-filters-item",
    class: {
      active: _vm.topFilter === 'az'
    },
    on: {
      "click": function($event) {
        _vm.topFilter = 'az'
      }
    }
  }, [_c('span', [_vm._v("A - Z")])]), _vm._v(" "), _c('div', {
    staticClass: "browse-filters-item",
    class: {
      active: _vm.topFilter === 'thematic'
    },
    on: {
      "click": function($event) {
        _vm.topFilter = 'thematic'
      }
    }
  }, [_c('span', [_vm._v("Thematic Sections")])]), _vm._v(" "), _c('div', {
    staticClass: "browse-filters-item",
    class: {
      active: _vm.topFilter === 'authors'
    },
    on: {
      "click": function($event) {
        _vm.topFilter = 'authors'
      }
    }
  }, [_c('span', [_vm._v("Authors")])]), _vm._v(" "), _c('div', {
    staticClass: "browse-filters-item",
    class: {
      active: _vm.topFilter === 'search'
    },
    on: {
      "click": function($event) {
        _vm.topFilter = 'search'
      }
    }
  }, [_vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "browse-content"
  }, [(_vm.topFilter === 'az') ? _c('div', [_c('div', {
    staticClass: "browse-letters"
  }, [_vm._l((_vm.alphabet), function(letter) {
    return _c('span', {
      class: {
        active: _vm.azFilter === letter
      },
      on: {
        "click": function($event) {
          return _vm.setAzFilter(letter)
        }
      }
    }, [_vm._v(_vm._s(letter) + "\n            ")])
  }), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('div', {
    staticClass: "browse-blocks"
  }, _vm._l((_vm.alphabet), function(letter) {
    return _c('div', {
      staticClass: "browse-blocks-item",
      class: {
        active: _vm.azFilter === letter
      }
    }, [_c('div', {
      staticClass: "browse-blocks-title"
    }, [_vm._v("\n                " + _vm._s(letter) + "\n              ")]), _vm._v(" "), _c('ul', _vm._l((_vm.filteredTerms(letter)), function(term) {
      return _c('li', _vm._l((_vm.articleList), function(article) {
        return (article.term_id === term.id) ? _c('router-link', {
          attrs: {
            "to": '/article/' + article.id
          }
        }, [_vm._v("\n                    " + _vm._s(term.term_english) + "\n                  ")]) : _vm._e()
      }), 1)
    }), 0)])
  }), 0), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.topFilter === 'thematic') ? _c('div', [_c('div', {
    staticClass: "browse-themes"
  }, _vm._l((_vm.sectionList), function(section, index) {
    return (index <= 4) ? _c('div', {
      on: {
        "click": function($event) {
          _vm.themFilter = section.id
        }
      }
    }, [_c('span', {
      class: {
        active: _vm.themFilter === section.id
      }
    }, [_vm._v("\n                " + _vm._s(section.long_name) + "\n              ")])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "list-intro"
  }, [(_vm.themFilter == 1) ? _c('p', [_c('span', {
    staticClass: "lit"
  }, [_vm._v("1. Epistemologies")]), _vm._v("\n              This thematic section will gather and evaluate the\n              theoretical-critical vocabulary that orients the investigation\n              of colonial and postcolonial contexts and, in particular, the\n              socio-cultural phenomena arising from them. The major fields of\n              research addressed in this section are: anthropology, sociology,\n              cultural theory and cultural studies, postcolonial studies,\n              linguistics, narratology, image theory and visual studies,\n              semiotics, among others.\n              "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.themFilter == 2) ? _c('p', [_c('span', {
    staticClass: "lit"
  }, [_vm._v("2. History and Genealogy")]), _vm._v("\n              This section will explore the historical context of colonialism,\n              with its unique set of tensions and conflicts that served as a\n              backdrop for the movements, wars, and phenomena that make up the\n              Afro-European relationship (colonies, decolonization, colonial\n              wars, anti-colonial struggles, imperialism, etc). The aim is to\n              reference the phenomena and the events while identifying the\n              processes and features that differentiate them. The role of this\n              section is to discuss heterogeneous and discontinuous phenomena\n              in order to map the relationships and tensions between them.\n              "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.themFilter == 3) ? _c('p', [_c('span', {
    staticClass: "lit"
  }, [_vm._v("3. Cultural Practices and Performativities")]), _vm._v("\n              This section addresses the cultural practices and the new forms\n              of performativity rooted in communities situated within the\n              Afro-European intercultural dialogue. The aim is to map out the\n              processes of the transubjectivation of identity - embodied in\n              habits, practices, customs, activist representations and claims\n              - of communities that are defined by this intercultural\n              experience. This section thus focus on cultural practices and\n              performativity as dynamic processes, imbued with contamination\n              and cultural hybridization and reflected in corporeality, in the\n              miscegenation of discourse, in the mixing of symbols, in new\n              representations and in the quest for identity.\n              "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.themFilter == 4) ? _c('p', [_c('span', {
    staticClass: "lit"
  }, [_vm._v("4. Linguistic Uses")]), _vm._v("\n              This section is subdivided into two glossaries: one of them\n              containing Terms, and the other one containing Lexical Units.\n              "), _c('br'), _vm._v("\n              The first glossary – Terms – presents the definition of\n              metalinguistic concepts specifically used in the Communication\n              and Language Sciences in order to enable a better understanding\n              of discursivities that take place between the African and\n              European continents and their intercultural dimension. This\n              intercultural dimension is the result of the contacts between\n              the various languages spoken in Africa and Europe and the\n              balance of power, which can be explained from a linguistic point\n              of view, but also from a sociological, anthropological,\n              political, and geographical point of view.\n              "), _c('br'), _vm._v("\n              The second glossary – Lexical Units – gathers vocabulary\n              resulting from the lexical contact and the loans into and from\n              languages spoken in Africa and Europe. We intend to collect\n              words that have deviations in meaning and form (neologisms),\n              registering the new uses that these units have gained both in\n              everyday language and figuratively, i.e., in poetic or literary\n              senses.\n              "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.themFilter == 5) ? _c('p', [_c('span', {
    staticClass: "lit"
  }, [_vm._v("5. Arts and Imaginaries")]), _vm._v("\n              This section deals with the colonial and postcolonial\n              imaginaries and with the creative practices that reflect or\n              deconstruct them (within and outside the institution of art) in\n              the fields of literature, film, visual arts, installation and\n              architecture, theatre and performance, music and dance. Its\n              purpose is to highlight the contribution made by literature and\n              artistic practices to the development of postcolonial thinking,\n              as well as the complex coexistence and relation between\n              modernism and the colonial contexts of the first half of the\n              twentieth century. In the face of the new cultural histories and\n              geographies stemming from globalization, as well as the\n              influential Western encoding of contemporary artistic culture,\n              the approach in this section will also examine what may come\n              after the creative and curatorial strategies of postcolonialism.\n            ")]) : _vm._e()]), _vm._v(" "), (_vm.themFilter !== 4) ? _c('div', [_c('div', {
    staticClass: "browse-letters"
  }, [_vm._l((_vm.alphabet), function(letter) {
    return _c('span', {
      class: {
        active: _vm.azFilter === letter
      },
      on: {
        "click": function($event) {
          return _vm.setAzFilter(letter)
        }
      }
    }, [_vm._v(_vm._s(letter) + "\n              ")])
  }), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('div', {
    staticClass: "browse-blocks general"
  }, _vm._l((_vm.alphabet), function(letter) {
    return _c('div', {
      staticClass: "browse-blocks-item",
      class: {
        active: _vm.azFilter === letter
      }
    }, [_c('div', {
      staticClass: "browse-blocks-title"
    }, [_vm._v("\n                  " + _vm._s(letter) + "\n                ")]), _vm._v(" "), _c('ul', _vm._l((_vm.filteredTerms(letter)), function(term) {
      return (term.section_id == _vm.themFilter) ? _c('li', _vm._l((_vm.articleList), function(article) {
        return (article.term_id === term.id) ? _c('router-link', {
          attrs: {
            "to": '/article/' + article.id
          }
        }, [_vm._v("\n                      " + _vm._s(term.term_english) + "\n                    ")]) : _vm._e()
      }), 1) : _vm._e()
    }), 0)])
  }), 0), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.themFilter === 4) ? _c('div', {
    staticClass: "browse-themes"
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.subThemFilter = 'general'
      }
    }
  }, [_c('span', {
    class: {
      active: _vm.subThemFilter === 'general'
    }
  }, [_vm._v("\n                Terms\n              ")])]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.subThemFilter = 'lexical'
      }
    }
  }, [_c('span', {
    class: {
      active: _vm.subThemFilter === 'lexical'
    }
  }, [_vm._v("\n                Lexical Units\n              ")])])]) : _vm._e(), _vm._v(" "), (_vm.themFilter === 4 && _vm.subThemFilter === 'lexical') ? _c('div', {
    staticClass: "lang-select"
  }, [_c('div', {
    staticClass: "lang-select-item"
  }, [_c('label', [_vm._v("Target Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.langTarget),
      expression: "langTarget"
    }],
    staticClass: "inline",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.langTarget = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All languages")]), _vm._v(" "), _vm._l((_vm.apiLanguages), function(lang) {
    return _c('option', {
      domProps: {
        "value": lang.id
      }
    }, [_vm._v("\n                  " + _vm._s(lang.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "lang-select-item"
  }, [_c('label', [_vm._v("Source Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.langSource),
      expression: "langSource"
    }],
    staticClass: "inline",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.langSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All languages")]), _vm._v(" "), _vm._l((_vm.apiLanguages), function(lang) {
    return _c('option', {
      domProps: {
        "value": lang.id
      }
    }, [_vm._v("\n                  " + _vm._s(lang.name) + "\n                ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.themFilter === 4) ? _c('div', {
    staticClass: "browse-letters"
  }, [_vm._l((_vm.alphabet), function(letter) {
    return _c('span', {
      class: {
        active: _vm.themAzFilter === letter
      },
      on: {
        "click": function($event) {
          return _vm.setThemAzFilter(letter)
        }
      }
    }, [_vm._v(_vm._s(letter) + "\n            ")])
  }), _vm._v(" "), _c('br')], 2) : _vm._e(), _vm._v(" "), (_vm.themFilter === 4 && _vm.subThemFilter === 'general') ? _c('div', {
    staticClass: "browse-blocks lexic-term"
  }, _vm._l((_vm.alphabet), function(letter) {
    return _c('div', {
      staticClass: "browse-blocks-item",
      class: {
        active: _vm.themAzFilter === letter
      }
    }, [_c('div', {
      staticClass: "browse-blocks-title"
    }, [_vm._v("\n                " + _vm._s(letter) + "\n              ")]), _vm._v(" "), _c('ul', _vm._l((_vm.filteredTerms(letter)), function(term) {
      return (term.section_id == _vm.themFilter) ? _c('li', [_vm._l((_vm.articleList), function(article) {
        return (article.term_id === term.id) ? _c('router-link', {
          attrs: {
            "to": '/article/' + article.id
          }
        }, [_vm._v("\n                    " + _vm._s(term.term_english) + " ")]) : _vm._e()
      }), _c('br')], 2) : _vm._e()
    }), 0)])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.themFilter === 4 && _vm.subThemFilter === 'lexical') ? _c('div', {
    staticClass: "browse-blocks lexic-unit"
  }, _vm._l((_vm.alphabet), function(letter) {
    return _c('div', {
      staticClass: "browse-blocks-item",
      class: {
        active: _vm.themAzFilter === letter
      }
    }, [_c('div', {
      staticClass: "browse-blocks-title"
    }, [_vm._v("\n                " + _vm._s(letter) + "\n              ")]), _vm._v(" "), _c('ul', _vm._l((_vm.filteredUnits(letter)), function(term) {
      return (
        (_vm.langTarget === '0' && _vm.langSource === '0') ||
        (_vm.langTarget === term.lang_occu_id &&
          _vm.langSource === term.lang_orig_id) ||
        (_vm.langTarget === '0' &&
          _vm.langSource === term.lang_orig_id) ||
        (_vm.langTarget === term.lang_occu_id && _vm.langSource === '0')
      ) ? _c('li', [_c('router-link', {
        attrs: {
          "to": '/lexical/' + term.id
        }
      }, [_vm._v("\n                    " + _vm._s(term.term_english) + " ")]), _c('br')], 1) : _vm._e()
    }), 0)])
  }), 0) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.topFilter === 'authors') ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "browse-blocks general browse-blocks-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authorSearcher),
      expression: "authorSearcher"
    }],
    staticClass: "search",
    attrs: {
      "placeholder": "Search author surname"
    },
    domProps: {
      "value": (_vm.authorSearcher)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.authorSearcher = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "browse-blocks-item active"
  }, [_c('div', {
    staticClass: "browse-blocks-title"
  }), _vm._v(" "), _c('ul', _vm._l((_vm.termList), function(term) {
    return _c('li', _vm._l((_vm.articleList), function(article) {
      return (
        article.term_id === term.id &&
        article.author_surname
        .toLowerCase()
        .includes(_vm.authorSearcher.toLowerCase()) &&
        _vm.authorSearcher
      ) ? _c('router-link', {
        attrs: {
          "to": '/article/' + article.id
        }
      }, [_vm._v("\n                    " + _vm._s(term.term_english) + " by " + _vm._s(article.author_name) + "\n                    " + _vm._s(article.author_surname) + "\n                  ")]) : _vm._e()
    }), 1)
  }), 0)])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.topFilter === 'search') ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "browse-blocks general browse-blocks-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searcher),
      expression: "searcher"
    }],
    staticClass: "search",
    attrs: {
      "placeholder": "Search term or lexical unit"
    },
    domProps: {
      "value": (_vm.searcher)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searcher = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "browse-blocks-item active"
  }, [_c('div', {
    staticClass: "browse-blocks-title"
  }), _vm._v(" "), _c('ul', [_vm._l((_vm.termList), function(term) {
    return (
      term.term_english
      .toLowerCase()
      .includes(_vm.searcher.toLowerCase()) && _vm.searcher
    ) ? _c('li', _vm._l((_vm.articleList), function(article) {
      return (article.term_id === term.id) ? _c('router-link', {
        attrs: {
          "to": '/article/' + article.id
        }
      }, [_vm._v("\n                    " + _vm._s(term.term_english) + "\n                  ")]) : _vm._e()
    }), 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.lexicalList), function(lexical) {
    return (
      lexical.term_english
      .toLowerCase()
      .includes(_vm.searcher.toLowerCase()) && _vm.searcher
    ) ? _c('li', {
      staticClass: "search-lexical"
    }, [_c('router-link', {
      attrs: {
        "to": '/lexical/' + lexical.id
      }
    }, [_c('span', [_vm._v(_vm._s(lexical.term_english))])])], 1) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('br')]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (!_vm.browse) ? _c('div', [_vm._m(2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-intro"
  }, [_c('div', {
    staticClass: "list-intro-block"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icon.png"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Afro-European Cartography of Culture, Language and Arts")]), _vm._v(" "), _c('i', [_vm._v("Glossary")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_vm._v("\n      The Afro-European Cartography of Culture, Language and Arts is a\n      research and publishing initiative of the project African-European\n      Narratives (started under Europe For Citizens Programme). Its goal is to\n      map the interplay between African and European cultures through various\n      perspectives (historical, epistemological, social, political, linguistic\n      and aesthetical) and to provide greater access to the scholarly\n      discussion on multicultural and post-colonial societies, as a relevant\n      dimension of knowledge citizenship.\n      "), _c('br'), _c('br'), _vm._v("\n      This cartography will evolve as progressive Glossary, a compilation of\n      terms and descriptions through the use of open and collaborative access\n      since stakeholders can either add new terms and descriptions or write\n      new articles for existing entries. Such openness will not preclude the\n      careful selection of terms and a methodological approach to the whole,\n      that will be ensured by a Scientific and Editorial Board and the\n      peer-review of submitted articles.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "/static/img/icons/search2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-intro"
  }, [_vm._v("\n      The terms and descriptions are grouped thematically, and not only then\n      alphabetically, so that fruitful links may be set up and encourage\n      intratextual readings. As a starting point, this Afro-European\n      Cartography invites research and writing to approach five main domains:\n      "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "lit"
  }, [_vm._v("1. Epistemologies")]), _vm._v("\n      This thematic section will gather and evaluate the theoretical-critical\n      vocabulary that orients the investigation of colonial and postcolonial\n      contexts and, in particular, the socio-cultural phenomena arising from\n      them. The major fields of research addressed in this section are:\n      anthropology, sociology, cultural theory and cultural studies,\n      postcolonial studies, linguistics, narratology, image theory and visual\n      studies, semiotics, among others.\n      "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "lit"
  }, [_vm._v("2. History and Genealogy")]), _vm._v("\n      This section will explore the historical context of colonialism, with\n      its unique set of tensions and conflicts that served as a backdrop for\n      the movements, wars, and phenomena that make up the Afro-European\n      relationship (colonies, decolonization, colonial wars, anti-colonial\n      struggles, imperialism, etc). The aim is to reference the phenomena and\n      the events while identifying the processes and features that\n      differentiate them. The role of this section is to discuss heterogeneous\n      and discontinuous phenomena in order to map the relationships and\n      tensions between them.\n      "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "lit"
  }, [_vm._v("3. Cultural Practices and Performativities")]), _vm._v("\n      This section addresses the cultural practices and the new forms of\n      performativity rooted in communities situated within the Afro-European\n      intercultural dialogue. The aim is to map out the processes of the\n      transubjectivation of identity - embodied in habits, practices, customs,\n      activist representations and claims - of communities that are defined by\n      this intercultural experience. This section thus focus on cultural\n      practices and performativity as dynamic processes, imbued with\n      contamination and cultural hybridization and reflected in corporeality,\n      in the miscegenation of discourse, in the mixing of symbols, in new\n      representations and in the quest for identity.\n      "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "lit"
  }, [_vm._v("4. Linguistic Uses")]), _vm._v("\n      The aim, in this section, is the gathering of a meta-language of\n      critical and analytical terms about language usage, as well as the\n      indexation of specific vocabulary derived from intercultural migrations\n      between African and European languages. The definition presented for\n      each of these lexical terms intends to account for its occurrences in a\n      target language and possible lexical and semantic transformations. The\n      section will set up a cartography of loans, linguistic contaminations in\n      both directions, from European languages to African languages and vice\n      versa. The interest is also to detect the deviations of meaning, new\n      usages, neologisms or adoption of terms that refer to migrations of\n      cultural practices, as well as a poetics of the language present, for\n      example, in literature. This collection also has a performative effect\n      on postcolonial epistemes in the sense that it provides us with a\n      dialogical perspective on cultures and a with linguistic ecology that\n      invites us to question the idea of indentitary monolinguism.\n      "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "lit"
  }, [_vm._v("5. Arts and Imaginaries")]), _vm._v("\n      This section deals with the colonial and postcolonial imaginaries and\n      with the creative practices that reflect or deconstruct them (within and\n      outside the institution of art) in the fields of literature, film,\n      visual arts, installation and architecture, theatre and performance,\n      music and dance. Its purpose is to highlight the contribution made by\n      literature and artistic practices to the development of postcolonial\n      thinking, as well as the complex coexistence and relation between\n      modernism and the colonial contexts of the first half of the twentieth\n      century. In the face of the new cultural histories and geographies\n      stemming from globalization, as well as the influential Western encoding\n      of contemporary artistic culture, the approach in this section will also\n      examine what may come after the creative and curatorial strategies of\n      postcolonialism.\n      "), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Scientific Editorial Board")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      Achille Mbembe (University of Johannesburg; Duke University, USA)\n      "), _c('br'), _vm._v("\n      Alain Kiyindou (Université Bordeaux-Montaigne, Chair UNESCO)\n      "), _c('br'), _vm._v("\n      Alexandra Magnólia Dias (NOVA University – IPRI)\n      "), _c('br'), _vm._v("\n      Ana Balona de Oliveira (NOVA University – IHA / Univeristy of Lisbon –\n      CEC)\n      "), _c('br'), _vm._v("\n      Ana Maria Martinho (NOVA University – CHAM)\n      "), _c('br'), _vm._v("\n      Ana Paula Tavares (University of Lisbon – CLEPUL)\n      "), _c('br'), _vm._v("\n      Angela Ferreira (Faculty of Beaux-Arts, Univ. of Lisbon – CIEBA)\n      "), _c('br'), _vm._v("\n      António Tomaz (University of Johannesburg)\n      "), _c('br'), _vm._v("\n      António Sousa Ribeiro (University of Coimbra – CES)\n      "), _c('br'), _vm._v("\n      Boaventura Sousa Santos (University of Coimbra – CES)\n      "), _c('br'), _vm._v("\n      Bonaventure Soh Bejeng Ndikung (Savvy Contemporary, Berlin)\n      "), _c('br'), _vm._v("\n      Elisio Macamo (University of Basel)\n      "), _c('br'), _vm._v("\n      Fernando Rosas (NOVA University – IHC)\n      "), _c('br'), _vm._v("\n      Iolanda Évora (ISEG - Center of Studies on Africa and Development)\n      "), _c('br'), _vm._v("\n      Inocência Mata (University of Lisbon – CEC)\n      "), _c('br'), _vm._v("\n      Manuela Ribeiro Sanches (University of Lisbon – CEC)\n      "), _c('br'), _vm._v("\n      Margarida Calafate Ribeiro (University of Coimbra – CES)\n      "), _c('br'), _vm._v("\n      Maria Paula Meneses (University of Coimbra – CES)\n      "), _c('br'), _vm._v("\n      Miguel Cardina (University of Coimbra – CES)\n      "), _c('br'), _vm._v("\n      Moisés Lemos Martins (Minho University - CECS\n      "), _c('br'), _vm._v("\n      Paula Nascimento (Curator, Beyond Entropy Africa)\n      "), _c('br'), _vm._v("\n      Paul Goodwin (University of the Arts, London)\n      "), _c('br'), _vm._v("\n      Paulo Inglês (University of Beyreuth and Polytechnic Institute Jean\n      Piaget, Benguela)\n      "), _c('br'), _vm._v("\n      Pedro Aires de Oliveira (NOVA University – IHC)\n      "), _c('br'), _vm._v("\n      Ricardo Roque (University of Lisbon – ICS)\n      "), _c('br'), _vm._v("\n      Ricardo Soares de Oliveira (Oxford University – St Peter’s College)\n      "), _c('br'), _vm._v("\n      Rute Costa (NOVA University of Lisbon – CLUNL)\n      "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Executive Editorial Board")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('i', [_vm._v("Coordinator")]), _vm._v(":\n      Maria Augusta Babo (NOVA University of Lisbon – ICNOVA)\n      "), _c('br'), _vm._v("\n      Cláudia Madeira (NOVA University of Lisbon – ICNOVA)\n      "), _c('br'), _vm._v("\n      Madalena Miranda (NOVA University of Lisbon – IHC)\n      "), _c('br'), _vm._v("\n      Maria Teresa Cruz (NOVA University of Lisbon – ICNOVA)\n      "), _c('br'), _vm._v("\n      Marta Lança (NOVA University of Lisbon – IHA)\n      "), _c('br'), _vm._v("\n      Pedro Aires de Oliveira (NOVA University of Lisbon – IHC)\n      "), _c('br'), _vm._v("\n      Rute Costa (NOVA University of Lisbon – CLUNL)\n      "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Webmaster")]), _vm._v(": \n      Inês Ponte (Lisbon University - ICS)\n      "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Invited Editors")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Web Design and Development")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://bagabagastudios.org/"
    }
  }, [_vm._v("Bagabaga Studios")]), _c('br'), _vm._v("\n      Ana Grave, Vasco Borges, Manuel Almeida\n      "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Editorial Information")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticClass: "small"
  }, [_vm._v("Publishers")]), _vm._v(" "), _c('br'), _vm._v("\n      ICNOVA - Institute of Communication of NOVA Univeristy of Lisbon\n      (icnova.fcsh.unl.pt/)\n      "), _c('br'), _vm._v("\n      BUALA – Multidisciplinary Portal on Decolonization and Global South\n      Issues (buala.org)\n      "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticClass: "small"
  }, [_vm._v("ISSN")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://africaneuropeanarratives.eu/en/terms-of-use-privacy-policy#terms-conditions"
    }
  }, [_c('b', {
    staticClass: "small"
  }, [_vm._v("Terms of Use & Privacy Policy ")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Information for Authors")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticClass: "small"
  }, [_vm._v("Publication Norms & Template ")]), _vm._v(" "), _c('br'), _vm._v("\n      ["), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/static/pdf/subnormspdf_pt.pdf"
    }
  }, [_vm._v("PT")]), _vm._v("], ["), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/static/pdf/subnormspdf_en.pdf"
    }
  }, [_vm._v("EN")]), _vm._v("]\n      "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticClass: "small"
  }, [_vm._v("Special Calls")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticClass: "small"
  }, [_vm._v("How to cite this Glossary ")]), _vm._v(" "), _c('br'), _vm._v("\n      Author's Surname, Name. Year. “Article Title or Term: Subtitle (in case\n      it exists).” In Afro-European Cartography of Culture, Language and Arts.\n      Lisbon: ICNOVA and BUALA. "), _c('br'), _vm._v("\n      URL: http://africaneuropeanarratives.eu/en/glossary\n      "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticClass: "small"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "mailto:glossary@africaneuropeanarratives.eu"
    }
  }, [_vm._v("glossary@africaneuropeanarratives.eu")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fd9b20f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 174
// module chunks = 2